import Headshot from "components/general/Headshot";
import React from "react";
import styled from "styled-components";
import theme from "styles/theme";

const AnimationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 120px;
  height: 120px;

  ${theme.container.medium`
    display: none;
  `};
`;

const Container = styled.div`
  position: relative;
  width: 104px;
  height: 104px;
`;

const AnimationContainerSmall = styled.div`
  display: none;

  ${theme.container.medium`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 64px;
    height: 64px;
  `};

  ${theme.container.extraSmall`
    display: none;
  `};
`;

const ContainerSmall = styled.div`
  position: relative;
  width: 56px;
  height: 56px;
`;

const StyledHeadshot = styled(Headshot)`
  position: absolute;
  ${(props) => props.top && `top: ${props.top}px;`};
  ${(props) => props.right && `right: ${props.right}px;`};
  ${(props) => props.bottom && `bottom: ${props.bottom}px;`};
  ${(props) => props.left && `left: ${props.left}px;`};
`;

const HeadshotCircle = styled.div`
  position: absolute;
  right: 2px;
  bottom: 2px;

  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  font-family: "Degular";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;

  background-color: ${theme.colors.gray2};
`;

const HeadshotBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  background: #e1dfe9;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
  border-radius: 50%;

  position: absolute;
  right: 0;
  bottom: 0;

  font-family: "Degular";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  color: black;
`;

const Headshots = ({ className, speakers }) => {
  return (
    <div className={className}>
      <AnimationContainer>
        <Container>
          {speakers.length === 1 && (
            <StyledHeadshot
              src={speakers[0].headshotPhotoUrl}
              speaker={speakers[0]}
              size={104}
              borderWidth={0}
            />
          )}
          {speakers.length === 2 && (
            <>
              <StyledHeadshot
                src={speakers[0].headshotPhotoUrl}
                speaker={speakers[0]}
                size={48}
                borderWidth={0}
                top={28}
                left={2}
              />
              <StyledHeadshot
                src={speakers[1].headshotPhotoUrl}
                speaker={speakers[1]}
                size={48}
                borderWidth={0}
                top={28}
                right={2}
              />
            </>
          )}
          {speakers.length === 3 && (
            <>
              <StyledHeadshot
                src={speakers[0].headshotPhotoUrl}
                speaker={speakers[0]}
                size={48}
                borderWidth={0}
                top={2}
                left={2}
              />
              <StyledHeadshot
                src={speakers[1].headshotPhotoUrl}
                speaker={speakers[1]}
                size={48}
                borderWidth={0}
                top={2}
                right={2}
              />
              <StyledHeadshot
                src={speakers[2].headshotPhotoUrl}
                speaker={speakers[2]}
                size={48}
                borderWidth={0}
                bottom={2}
                left={28}
              />
            </>
          )}
          {speakers.length === 4 && (
            <>
              <StyledHeadshot
                src={speakers[0].headshotPhotoUrl}
                speaker={speakers[0]}
                size={48}
                borderWidth={0}
                top={2}
                left={2}
              />
              <StyledHeadshot
                src={speakers[1].headshotPhotoUrl}
                speaker={speakers[1]}
                size={48}
                borderWidth={0}
                top={2}
                right={2}
              />
              <StyledHeadshot
                src={speakers[2].headshotPhotoUrl}
                speaker={speakers[2]}
                size={48}
                borderWidth={0}
                bottom={2}
                left={2}
              />
              <StyledHeadshot
                src={speakers[3].headshotPhotoUrl}
                speaker={speakers[3]}
                size={48}
                borderWidth={0}
                right={2}
                bottom={2}
              />
            </>
          )}
          {speakers.length > 4 && (
            <>
              <StyledHeadshot
                src={speakers[0].headshotPhotoUrl}
                speaker={speakers[0]}
                size={48}
                borderWidth={0}
                top={2}
                left={2}
              />
              <StyledHeadshot
                src={speakers[1].headshotPhotoUrl}
                speaker={speakers[1]}
                size={48}
                borderWidth={0}
                top={2}
                right={2}
              />
              <StyledHeadshot
                src={speakers[2].headshotPhotoUrl}
                speaker={speakers[2]}
                size={48}
                borderWidth={0}
                bottom={2}
                left={2}
              />
              <HeadshotCircle>{`+${speakers.length - 3}`}</HeadshotCircle>
            </>
          )}
        </Container>
      </AnimationContainer>
      <AnimationContainerSmall>
        <ContainerSmall>
          {speakers.length === 1 && (
            <StyledHeadshot
              src={speakers[0].headshotPhotoUrl}
              speaker={speakers[0]}
              size={56}
              borderWidth={0}
            />
          )}
          {speakers.length > 1 && (
            <>
              <StyledHeadshot
                src={speakers[0].headshotPhotoUrl}
                speaker={speakers[0]}
                size={56}
                borderWidth={0}
              />
              <HeadshotBadge>{`+${speakers.length - 1}`}</HeadshotBadge>
            </>
          )}
        </ContainerSmall>
      </AnimationContainerSmall>
    </div>
  );
};

export default Headshots;
